module.exports = __webpack_public_path__ + "img/logo_spm_small.c2a389c2.png";